import { IStandardNavigationState } from "./standardNavigation.t";
import { Module } from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const moduleStandardNavigation: Module<IStandardNavigationState, any> = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeComponent: "",
    activeSubComponent: "",
    isStandardMenuOpen: true,
    isPreviousMenuStateOpen: true,
    lastComponentSwatchApplied: '',
    previousComponent: '',
    menu: [],
  }
};

export default moduleStandardNavigation;